import type { AnyString } from '@eshop/type'

import { Config } from '#/global/helper/Config'

export interface Props extends React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> {
    src: ListOfSvg
}
export const Svg = ({ src, ...props }: Props) => {
    return <img src={`${Config.getBaseCdn()}${src}`} loading="lazy" {...props} />
}

// eslint-disable-next-line style/operator-linebreak
export type ListOfSvg =
    | '/file/icon-eye-4d078dca.svg'
    | '/file/cancel-red-50912183.svg'
    | '/file/icon-eye-slash-7e727447.svg'
    | '/file/icon-info-circled-6d8bc63d.svg'
    | '/file/question-mark-8d952c32.svg'
    | '/file/user-40de0790.svg'
    | '/file/storefront-4ce29d7f.svg'
    | '/file/caret-down-36a70692.svg'
    | '/file/check-24d76791.svg'
    | '/file/arrow-thin-down-95726889.svg'
    | '/file/link-361e1c5b.svg'
    | '/file/truck-ee49c33a.svg'
    | '/file/payment-card-d7a4ed1c.svg'
    | '/file/home-cdc7139d.svg'
    | '/file/archive-351bde01.svg'
    | '/file/caret-down-961b7d1b.svg'
    | '/file/check-a27098c5.svg'
    | '/file/icon-down-open-25d60d8e.svg'
    | '/file/info-gray-2a8fce44.svg'
    | '/file/close-d223f96a.svg'
    | '/file/check-bd8d39da.svg'
    | '/file/close1-c69c49d5.svg'
    | '/file/file-text-d4d806da.svg'
    | '/file/calendar-e6a5322a.svg'
    | '/file/edit-0a9eeeb0.svg'
    | '/file/arrow-left-circle-7328df09.svg'
    | '/file/file-pdf-9e5ee1d5.svg'
    | '/file/eye-182d4b5a.svg'
    | '/file/eye-slash-86770d79.svg'
    | '/file/minus-406c2e3d.svg'
    | '/file/plus-93b3680b.svg'
    | '/file/info-6e7cbcd4.svg'
    | '/file/glossary-9ed9ab4b.svg'
    | '/file/check-7c33cfe0.svg'
    | '/file/arrow-left-7afb07cd.svg'
    | '/file/magnifier-ecbb68fb.svg'
    | '/file/icon-info-circled-green-0c830563.svg'
    | '/file/icon-cancel-33c97f2e.svg'
    | '/file/close1-a1a35462.svg'
    | '/file/bell-cc55c462.svg'
    | '/file/time-5635227a.svg'
    | '/file/info-red-c7bfb23c.svg'
    | '/file/icon-attention-red-f36b59ee.svg'
    | '/file/caret-down-ed137f5e.svg'
    | '/file/check-0596c68b.svg'
    | '/file/angle-down-eeeab5c0.svg'
    | '/file/phone-b85b8c28.svg'
    | '/file/close-white-3472c692.svg'
    | '/file/search-e6887500.svg'
    | '/file/plus-white-a6e119fe.svg'
    | '/file/icon-attention-8521d99c.svg'
    | '/file/close-c90d5197.svg'
    | '/file/download-a0ecbb20.svg'
    | '/file/gift-3a9a769b.svg'
    | '/file/4hours-d635651e.svg'
    | '/file/discount-6a479a7f.svg'
    | '/file/mapa-cr-opt-8f262bb7.svg'
    | '/file/icon-basket-empty-fd6b253d.svg'
    | '/file/icon-check-circle-860e6f07.svg'
    | '/file/icon-check-gift-35587fdb.svg'
    | '/file/icon-warning-143ec372.svg'
    | '/file/info-circle-11a4f1d1.svg'
    | '/file/letosdoma-3d27d8eb.svg'
    | '/file/map-cluesterer-c373e110.svg'
    | '/file/map-marker-c55289aa.svg'
    | '/file/map-pointer-c2cfc72b.svg'
    | '/file/plus-8fd53cec.svg'
    | '/file/refresh-6919a3a8.svg'
    | '/file/target-a67d5e6b.svg'
    | '/file/user-bf462de1.svg'
    | '/file/cursor-1fc194ca.svg'
    | '/file/calc-7ba2de86.svg'
    | '/file/list-cbcb1b2e.svg'
    | '/file/dek-logo-3d5e3743.svg'
    | '/file/dek-logo-white-fa2ef54e.svg'
    | '/file/argos-logo-67480915.svg'
    | '/file/icon-facebook-f6a4656f.svg'
    | '/file/facebook-7b6bb6d1.svg'
    | '/file/google-plus-45d8caaf.svg'
    | '/file/icon-linkedin-88f6aa5f.svg'
    | '/file/linkedin-c8f55723.svg'
    | '/file/icon-ssl-5c4034d2.svg'
    | '/file/icon-youtube-25ac504b.svg'
    | '/file/instagram-0deaca47.svg'
    | '/file/logo-overeno-small-4f72baf6.svg'
    | '/file/logo-overeno-small-sk-3d338957.svg'
    | '/file/mastercard-logo-2318ae61.svg'
    | '/file/shoproku2019-logo-61b35a5a.svg'
    | '/file/shoproku2020-logo-53542ec8.svg'
    | '/file/visa-logo-1116bf36.svg'
    | '/file/edge-logo-1a3297dc.svg'
    | '/file/chrome-logo-3bdc45f3.svg'
    | '/file/firefox-logo-100b4e34.svg'
    | '/file/icon-payment-error-245dcde6.svg'
    | '/file/icon-payment-waiting-6cbdf77b.svg'
    | AnyString
